export default __webpack_public_path__ + "images/residential-icon@2x.png?b4e4ce89fdf3f5866c02f8238dcc4fe3";